import { useParams } from 'react-router';

import PrivacyPolicyJa from './ja';
import PrivacyPolicyKo from './ko';
import PrivacyPolicyTh from './th';

const PrivacyPolicy = () => {
  const { language = 'ko' } = useParams();

  if (language === 'th') return <PrivacyPolicyTh />;
  else if (language === 'ja') return <PrivacyPolicyJa />;
  return <PrivacyPolicyKo />;
};

export default PrivacyPolicy;
